import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import { Control, Label } from "rbx";

import { ALL_ROUTES_VIEW_QUERY } from "../../../graphql/Routes/Routes.graphql";

import DataTable from "../../../components/DataTable";

import { ROUTE_VIEW_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import RouteFilters from "./RouteFilters";
import { getFilterState, saveFilterState } from "../../../utils";

import { CustomerSelect } from "../../../components/inputs";

const RoutesPage = () => {
  const history = useHistory();
  const INITAL_FILTER_STATE = getFilterState("ROUTE_FILTERS", { Status: true });

  const [filters, setFilters] = useState(INITAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("ROUTE_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Status: true });

  const handleChange = e => {
    if (e.target.value) {
      const inputs = {
        ...filters,
        [e.target.name]: parseInt(e.target.value)
      };
      handleSetFilters(inputs);
    } else {
      // eslint-disable-next-line no-unused-vars
      const { CustomerRecIdRef, ...rest } = filters;
      handleSetFilters(rest);
    }
  };
  return (
    <div className="routes-page">
      <PageHeader
        FilterComponent={RouteFilters}
        columns={ROUTE_VIEW_COLUMNS}
        filters={filters}
        name="VW_Routes"
        query={ALL_ROUTES_VIEW_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Routes"
        onAddClick={() => history.push("/dispatch/routes/new")}
      >
        <Control>
          <Label>Customer</Label>
        </Control>
        <Control>
          <CustomerSelect
            icon="globe"
            label="Customer"
            name="CustomerRecIdRef"
            showLabel={false}
            value={filters.CustomerRecIdRef}
            variables={{
              where: { Active: true, OrderCust: true },
              orderByMulti: ["CustomerNo_ASC"]
            }}
            onChange={({ target: { name, value } }) => {
              handleChange({ target: { name, value } });
            }}
          />
        </Control>
      </PageHeader>
      <DataTable
        savePageIndex
        columns={ROUTE_VIEW_COLUMNS}
        dataQuery={ALL_ROUTES_VIEW_QUERY}
        initialSortBy={[
          { id: "CustomerNo", desc: false },
          { id: "RouteId", desc: false }
        ]}
        name="VW_Route"
        where={filters}
        onRowClick={data =>
          history.push(`/dispatch/routes/${data.RecId}/details`)
        }
      />
    </div>
  );
};
RoutesPage.propTypes = {};
export default RoutesPage;
